// extracted by mini-css-extract-plugin
export default {"banner":"NR","wrapper":"OR","selected_products":"PR","images":"QR","img":"RR","rounded_arrow":"SR","image-enter":"TR","image-enter-active":"UR","image-enter-done":"VR","image-exit":"WR","image-exit-active":"XR"};
    if(module.hot) {
      // 1715276859346
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  